<template>
  <div class="search">
    <input
      type="text"
      placeholder="请输入产品名称/编码"
      v-model="value"
      @keyup.enter="reset"
    />
    <div class="yellowbtn"  @click="reset">
      <Icon type="ios-search" size="18" color="#003871"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: sessionStorage.getItem('value') ? sessionStorage.getItem('value') : '',
    };
  },
  methods: {
    reset() { 
      if(this.$route.name == 'searchData'){
        this.$router.push({
        name:"searchData",
        query:{
          keyword:this.value
        }
      })
      sessionStorage.setItem('value',this.value)
      this.$router.go(0)
      }else{
        this.$router.push({
        name:"searchData",
        query:{
          keyword:this.value
        }
      })
      }
    }
  },
};
</script>

<style lang="less" scoped>
.search {
  position: relative;
  width: 310px;
  height: 40px;
  input {
    width: 310px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #f7b500;
    border-radius: 22px;
    padding-left: 15px;
    font-size: 12px;
  }
  input:focus{outline:none;}
  input::-webkit-input-placeholder {
    color: #696969;
    font-size: 12px;
  }
  .yellowbtn {
    cursor: pointer;
    position: absolute;
    top: 0px;
    left: 262px;
    width: 48px;
    height: 40px;
    background: #f7b500;
    border: 1px solid #f7b500;
    border-radius: 0px 22px 22px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>